import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=5604aef9"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=js"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports